var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg10(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140.059,
    height: 121.024,
    viewBox: "73.8262 51.6084 140.059 121.024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.899 168.632H187.449C194.085 168.632 199.457 166.578 203.565 162.47C207.779 158.257 209.885 152.832 209.885 146.196V76.0444C209.885 69.4084 207.779 64.0364 203.565 59.9284C199.457 55.7151 194.085 53.6084 187.449 53.6084H151.899C145.263 53.6084 139.839 55.7151 135.625 59.9284C131.517 64.0364 129.463 69.4084 129.463 76.0444V146.196C129.463 152.832 131.517 158.257 135.625 162.47C139.839 166.578 145.263 168.632 151.899 168.632ZM152.215 141.772V80.4684C152.215 76.8871 154.006 75.0964 157.587 75.0964H181.761C185.343 75.0964 187.133 76.8871 187.133 80.4684V141.772C187.133 145.354 185.343 147.144 181.761 147.144H157.587C154.006 147.144 152.215 145.354 152.215 141.772Z",
    fill: "#4E0109"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.899 168.632H187.449C194.085 168.632 199.457 166.578 203.565 162.47C207.779 158.257 209.885 152.832 209.885 146.196V76.0444C209.885 69.4084 207.779 64.0364 203.565 59.9284C199.457 55.7151 194.085 53.6084 187.449 53.6084H151.899C145.263 53.6084 139.839 55.7151 135.625 59.9284C131.517 64.0364 129.463 69.4084 129.463 76.0444V146.196C129.463 152.832 131.517 158.257 135.625 162.47C139.839 166.578 145.263 168.632 151.899 168.632ZM152.215 141.772V80.4684C152.215 76.8871 154.006 75.0964 157.587 75.0964H181.761C185.343 75.0964 187.133 76.8871 187.133 80.4684V141.772C187.133 145.354 185.343 147.144 181.761 147.144H157.587C154.006 147.144 152.215 145.354 152.215 141.772Z",
    fill: "url(#paint0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5242 166C94.5242 167.105 95.4196 168 96.5242 168H115.276C116.381 168 117.276 167.105 117.276 166V56.2402C117.276 55.1357 116.381 54.2402 115.276 54.2402H99.7125C99.4173 54.2402 99.1257 54.3056 98.8587 54.4316L74.9724 65.7071C74.2726 66.0375 73.8262 66.7419 73.8262 67.5158V82.3862C73.8262 83.7648 75.1881 84.73 76.4888 84.2733L91.8615 78.8752C93.1622 78.4185 94.5242 79.3837 94.5242 80.7622V166Z",
    fill: "#4E0109"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5242 166C94.5242 167.105 95.4196 168 96.5242 168H115.276C116.381 168 117.276 167.105 117.276 166V56.2402C117.276 55.1357 116.381 54.2402 115.276 54.2402H99.7125C99.4173 54.2402 99.1257 54.3056 98.8587 54.4316L74.9724 65.7071C74.2726 66.0375 73.8262 66.7419 73.8262 67.5158V82.3862C73.8262 83.7648 75.1881 84.73 76.4888 84.2733L91.8615 78.8752C93.1622 78.4185 94.5242 79.3837 94.5242 80.7622V166Z",
    fill: "url(#paint0)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter10",
    x: 73.8262,
    y: 51.6084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.968627 0 0 0 0 0.921569 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow",
    result: "effect3_innerShadow"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0",
    x1: 141.856,
    y1: 53.6084,
    x2: 197.4,
    y2: 169.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.398452,
    stopColor: "#C40F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8102E",
    stopOpacity: 0.1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg10);
export default __webpack_public_path__ + "static/media/10.a8ce4a3638532ae2152052399a5c542f.svg";
export { ForwardRef as ReactComponent };